module.exports = __webpack_public_path__ + "img/video-right.951eba74.png";